import { ApiBase } from '@/api/methods/ApiBase'
import {
  ApiResponseFixedExercise,
  ApiResponseActiveFixedExercise,
  ApiResponseFixedExerciseProblem,
} from '@/api/responses/fixedExercises'

export namespace FixedExercisesApi {
  /**
   * 固定問題取得
   *
   * @param fixedExerciseId 固定問題ID
   * @returns 固定問題情報
   */
  export async function getFixedExercise(fixedExerciseId: number): Promise<ApiResponseFixedExercise> {
    return await ApiBase.get(`fixedExercises/${fixedExerciseId}`)
  }

  /**
   * 最新固定問題取得
   *
   * @param curriculumUnitId 単元ID
   * @param level レベル
   * @returns 条件に一致する最新バージョンの固定問題情報
   */
  export async function getActive(curriculumUnitId: number, level: number): Promise<ApiResponseActiveFixedExercise> {
    const params = {
      curriculumUnitId: curriculumUnitId,
      level: level,
    }
    return await ApiBase.get('fixedExercises/active', params)
  }

  /**
   * 固定問題と小問コードから小問情報を取得
   *
   * @param fixedExerciseId 固定問題ID
   * @param problemCode 小問コード
   * @returns 小問情報
   */
  export async function getProblem(
    fixedExerciseId: number,
    problemCode: string
  ): Promise<ApiResponseFixedExerciseProblem> {
    return await ApiBase.get(`fixedExercises/${fixedExerciseId}/problems/${problemCode}`)
  }
}
